// vendor
import { PropType } from "@vue/composition-api";
// local
import { NodeData } from "./NodeData";

export function getProps<T>(){
	return {
		nodeId:{
			type:String,
			required:true
		},
		node:{
			type:Object as PropType<NodeData<T>>,
			required:true
		},
		showBack:{
			type:Boolean,
			default:false
		},
		isLast:{
			type:Boolean,
			default:false
		}
	}
};